// src/utils/languageMeta.js
export const languageMeta = {
  en: { name: "English", flag: "🇺🇸" },
  es: { name: "Español", flag: "🇪🇸" },
  fr: { name: "Français", flag: "🇫🇷" },
  de: { name: "Deutsch", flag: "🇩🇪" },
  hi: { name: "हिन्दी", flag: "🇮🇳" },
  zh: { name: "中文", flag: "🇨🇳" },
  ja: { name: "日本語", flag: "🇯🇵" },
  ru: { name: "Русский", flag: "🇷🇺" },
  ar: { name: "العربية", flag: "🇸🇦" },
  pt: { name: "Português", flag: "🇧🇷" },
  tr: { name: "Türkçe", flag: "🇹🇷" },
  ko: { name: "한국어", flag: "🇰🇷" },
  it: { name: "Italiano", flag: "🇮🇹" },
  nl: { name: "Nederlands", flag: "🇳🇱" },
  sv: { name: "Svenska", flag: "🇸🇪" },
  pl: { name: "Polski", flag: "🇵🇱" },
  he: { name: "עברית", flag: "🇮🇱" },
  th: { name: "ไทย", flag: "🇹🇭" },
  id: { name: "Bahasa Indonesia", flag: "🇮🇩" },
  vi: { name: "Tiếng Việt", flag: "🇻🇳" },
  fa: { name: "فارسی", flag: "🇮🇷" },
  ur: { name: "اردو", flag: "🇵🇰" },
  ro: { name: "Română", flag: "🇷🇴" },
  cs: { name: "Čeština", flag: "🇨🇿" },
  el: { name: "Ελληνικά", flag: "🇬🇷" },
  hu: { name: "Magyar", flag: "🇭🇺" },
  bn: { name: "বাংলা", flag: "🇧🇩" },
  ta: { name: "தமிழ்", flag: "🇮🇳" },
  te: { name: "తెలుగు", flag: "🇮🇳" },
  ml: { name: "മലയാളം", flag: "🇮🇳" },
  kn: { name: "ಕನ್ನಡ", flag: "🇮🇳" },
  gu: { name: "ગુજરાતી", flag: "🇮🇳" },
  pa: { name: "ਪੰਜਾਬੀ", flag: "🇮🇳" },
  mr: { name: "मराठी", flag: "🇮🇳" },
  uk: { name: "Українська", flag: "🇺🇦" },
  sr: { name: "Српски", flag: "🇷🇸" },
  hr: { name: "Hrvatski", flag: "🇭🇷" },
  sk: { name: "Slovenčina", flag: "🇸🇰" },
  fi: { name: "Suomi", flag: "🇫🇮" },
  no: { name: "Norsk", flag: "🇳🇴" },
  da: { name: "Dansk", flag: "🇩🇰" },
  sw: { name: "Kiswahili", flag: "🇰🇪" },
};
